import BicesterToolbar, { NavTab } from '@/components/layouts/BicesterToolbar';
import { VILLAGE_TYPE } from '@/constants';
import usePrefix from '@/hooks/usePrefix';
import useRouter from '@/hooks/useRouter';
import useTabs from '@/hooks/useTabs';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { replace } from '@/utils/history';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import MatchMember from './components/MatchMember';
import { SITE_SERVICE_TABS } from './constants';

const siteServiceTabs: NavTab[] = [
  { label: '租赁服务', key: SITE_SERVICE_TABS.LEASE, url: '/site-service/lease' },
  {
    label: '发票登记',
    key: SITE_SERVICE_TABS.INVOICE,
    url: '/site-service/invoice',
  },
  {
    label: '退税登记',
    key: SITE_SERVICE_TABS.DRAWBACK,
    url: '/site-service/drawback',
  },
  { label: '礼品包装', key: SITE_SERVICE_TABS.GIFTWRAP, url: '/site-service/giftwrap' },
  { label: '商品快递', key: SITE_SERVICE_TABS.EXPRESS, url: '/site-service/express' },
  { label: '第三方积分', key: SITE_SERVICE_TABS.THIRD, url: '/site-service/third' },
  { label: '投诉建议', key: SITE_SERVICE_TABS.SUGGEST, url: '/site-service/suggest' },
  { label: '失物招领', key: SITE_SERVICE_TABS.L_AND_F, url: '/site-service/l-and-f' },
  { label: '行李寄存', key: SITE_SERVICE_TABS.LUGGAGE, url: '/site-service/luggage' },
  { label: '其他服务', key: SITE_SERVICE_TABS.OTHER, url: '/site-service/other' },
  { label: '服务记录', key: SITE_SERVICE_TABS.RECORD, url: '/site-service/record' },
];

export interface Member {
  id?: number;
  level?: string | number;
  name?: string;
  sex?: string;
}

interface SiteContextValue {
  member?: Member;
  setMember?: (member: Partial<Member>) => void;
}

export const SiteContext = React.createContext<SiteContextValue>(null);

const SiteService = ({ children }: { children: React.ReactNode }) => {
  const { prefix, classname } = usePrefix('bicester-siteservice');

  const [member, setMember] = useState<Member>(null);

  const { tabs, activeTab, onChangeTab } = useTabs<string>(siteServiceTabs);

  const { pathname } = useRouter();
  const currentTab = useMemo(() => tabs.find((tab) => pathname.includes(tab.url)), [pathname]);

  const getDefaultTab = (navTab) => {
    return _.get(navTab, '[0].key', '');
  };

  useEffect(() => {
    if (pathname === '/site-service') {
      replace('/site-service/lease');
    } else {
      onChangeTab(currentTab ? currentTab.key : getDefaultTab(tabs));
      setMember(null);
    }
  }, [pathname]);

  return (
    <div className={classname}>
      <BicesterToolbar>
        <BicesterToolbar.NavBar data={tabs} activeTab={activeTab} isActiveDefault />
      </BicesterToolbar>
      <SiteContext.Provider value={{ member, setMember }}>
        {activeTab === SITE_SERVICE_TABS.L_AND_F || activeTab === SITE_SERVICE_TABS.RECORD ? ( // 失物招领和服务记录不需要匹配客户
          children
        ) : (
          <>
            <MatchMember
              member={member}
              setMember={setMember}
              height={
                !member?.id
                  ? 'calc(100vh - var(--headerHeight) - var(--navBarHeight) - var(--toolBarHeight))'
                  : 'auto'
              }
            />
            {member?.id && children}
          </>
        )}
      </SiteContext.Provider>
    </div>
  );
};

export default SiteService;
